
import Vue from 'vue';
import Component from 'vue-class-component';
import { ListsType } from 'rt/Core/ListsType';
import BaseTag from './BaseTag';
import { ReferrerCategoryController } from 'rt/UIApiControllers/BusinessObject/DTO';
import { IInt64ListResult } from 'rt/UIApiControllers/Controls/IInt64ListResult';

@Component({
  name: 'ReferrerCategoryTag',
})
export default class ReferrerCategoryTag extends BaseTag {
  referrerCategoryController = new ReferrerCategoryController(Vue.axios);

  async createNewTag(text: string, global: boolean): Promise<number> {
    const newInstance = await this.referrerCategoryController.GetNewInstance();
    newInstance.description = text;
    newInstance.personal = !global;
    return await this.referrerCategoryController.CreateOrUpdate(newInstance);
  }

  getListType(): ListsType {
    return this.$enums.ListsType.ListReferrerCategory;
  }
}
